export default __webpack_public_path__ + "bin-file/downloaded.svg";